export const zIndexes = {
  thresholdButton: 998,
  thresholdBackground: -1,
  circleButton: 999,
  selectButtonCheckIcon: 1,
  outlineSelectButton: 1,
  header: 999,
}
